const addColorToShelfTile = () => {
  const title = $('.shelf > h2');

  if (title.length <= 0) return;

  Array.from(title).map((t) => {
    const title = $(t);
    const sentenceArray = title.text().trim().split(' ');

    let sentenceCont = 2;
    if (sentenceArray.length <= 1) return;
    if (sentenceArray.length < 2) {
      sentenceCont = 1;
    }

    const normalSentece = sentenceArray.splice(0, sentenceArray.length - sentenceCont);

    title.html(`${normalSentece.join(' ')} <span> ${sentenceArray.join(' ')}</span>`);
  });
};

addColorToShelfTile();

export default {};
